module.exports = {"510522100":"合江镇","510522101":"望龙镇","510522102":"白沙镇","510522103":"佛荫镇","510522104":"先市镇","510522105":"尧坝镇","510522106":"九支镇","510522107":"五通镇","510522108":"凤鸣镇","510522109":"榕山镇","510522110":"白鹿镇","510522111":"甘雨镇","510522112":"福宝镇","510522113":"先滩镇","510522114":"自怀镇","510522115":"大桥镇","510522116":"车辋镇","510522117":"白米镇","510522118":"参宝镇","510522119":"法王寺镇","510522120":"虎头镇","510522121":"神臂城镇","510522122":"南滩镇","510522123":"实录镇","510522124":"石龙镇","510522125":"真龙镇","510522210":"榕右乡","510522400":"合江县临港工业园区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/510522.json
// module id = 2290
// module chunks = 0